
<template>
  <div>
    <template v-if="!loading && stages.length">
      <draggable disabled v-model="stages" v-bind="dragOptions" @change="reorder" @start="handleDragStart" @end="handleDragStop" draggable=".bacon" handle=".handle">
        <transition-group type="transition" :name="!is_dragging ? 'flip-list' : null">
          <show-one-stage v-for="(stage, idx) in stages" :key="stage.id" class="my-2 bacon handle" :style="{cursor: is_dragging? 'grabbing':'grab'}"
            :position="idx+1" :max_positions="stages.length" :stage="stage"
            @updatedStage="handleUpdatedStage"
          ></show-one-stage>
        </transition-group>
      </draggable>

    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import draggable_helpers from '@/mixins/draggable_helpers'
import Api from '@/api/index';
import ShowOneStage from './ShowOneStage.vue';
import entities from '@/utils/entities';

export default {
  name: 'TemplateStagesList',
  mixins: [ draggable_helpers ],
  components: {
    ShowOneStage,
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,

      entities: entities,

      stages: [],
      stages_bkp: [],

    }
  },
  methods: {
    reorder(){
      if (this.$can('edit', new entities.Stage('template'))) { 
        let obj = {
          id: this.$route.params.id,
          stages_attributes: this.stages.map((t, idx)=> {return {id: t.id, position: idx + 1, name: t.name}})
        }
        Api.Project.update(obj).then(r=>r.data).then(d=> {
          
        }).catch(err=> {
          console.log({err});
        }).finally(()=> {
  
        })
      } else {
        this.addNotification({type: 'error', msg: 'Alterações não foram salvas, pois não possui permissões para isso'})
      }
    },
    handleUpdatedStage(e){
      const idx = this.stages.findIndex(({id})=> id == e.id)
      if (idx > -1){
        this.stages.splice(idx, 1, {...e})
      }
      this.stages = this.stages.sort((a,b) => Number(a.position) - Number(b.position))
    },
    getStages() {
      this.loading = true
      Api.Stage.index({project_id: this.$route.params.id, use_type: ['template'], sorts: {position: 'asc'}}).then(r=>r.data).then(d=> {
        this.stages = [...d]
        this.stages_bkp = [...d]
      }).catch(err=> {
        console.log({err});
      }).finally(()=> this.loading = false)
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getStages();
  },
}
</script>

<style scoped>

</style>